import {
    DatasourceReturnType,
    ResponseError
} from 'models/common/respone.model';
import {
    PositionEmployeeRequest,
    PositionEmployee
} from '../schemas/PositionEmployeeLog.schema';
import {
    retrievePositionEmployeeLog
} from '../datasource/PositionEmployeeLog.datasource';

export async function getPositionEmployeeLog(
    params: PositionEmployeeRequest
): Promise<DatasourceReturnType<ResponseError, PositionEmployee>> {
    try {
        const data = (await retrievePositionEmployeeLog(params)).data;

        return [null!, data];
    } catch (error) {
        throw error;
    }
}